import { render } from "./RSVPList.vue?vue&type=template&id=641c34d6&scoped=true"
import script from "./RSVPList.vue?vue&type=script&lang=js"
export * from "./RSVPList.vue?vue&type=script&lang=js"

import "./RSVPList.vue?vue&type=style&index=0&id=641c34d6&lang=scss&scoped=true"

import exportComponent from "/Users/tvanderlin@ideo.com/Dev/davis-getting-married/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641c34d6"]])

export default __exports__